import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import CentralLink from './CentralLink.js';
import Button from 'react-bootstrap/Button';


function ProminentHalfLinkCard({ useFlagAsImage, image, title, body, buttonText, navigationTarget }) {
	let buttonTextComputed = buttonText ? buttonText : "Learn More";
	return (
		<Card className="h-100 shadow-sm">
			<Row className="align-items-center">
				<Col xs={3} className="d-flex justify-content-center align-items-center p-3">
					<CentralLink to={navigationTarget}>
						
						{ useFlagAsImage ? <span
							    className={"fi fi-" + useFlagAsImage}
							    style={{
							        display: "inline-block",           // Allows the icon to be treated as a block element
							        width: "95%",                      // Matches the Card.Img width
							        height: "140px",                   // Matches the Card.Img height
							        fontSize: "16em",                  // Fills the span container
							        textAlign: "center",               // Centers the flag horizontally
							        lineHeight: "140px",               // Centers the flag vertically
							        objectFit: "contain",              // Keeps the icon within the container
							        cursor: "pointer"                  // Matches cursor style of Card.Img
							    }}
							/> : 
							<Card.Img src={image} style={{ maxWidth: "95%", maxHeight: "140px", objectFit: "contain", "cursor": "pointer" }} />
						}
					</CentralLink>
				</Col>
				<Col xs={9}>
					<Card.Body>
						<CentralLink to={navigationTarget}>
							<Card.Title style={{ color: "rgb(33, 37, 41)", fontWeight: "bold", "cursor": "pointer" }} >{title}</Card.Title>
						</CentralLink>
						<Card.Text style={{ fontSize: "0.9rem" }}>
						  {body}
						</Card.Text>
						<div className="mt-3">
						  <CentralLink to={navigationTarget}>
						  	<Button variant="dark" size="sm" >{buttonTextComputed}</Button>
						  </CentralLink>
						</div>
					</Card.Body>
				</Col>
			</Row>
		</Card>
	);
}


export default ProminentHalfLinkCard;